import profileManagementActionType from '@constants/profileManagementActionType'

export default [
  {
    value: profileManagementActionType.MARK_AS_DEFAULT,
    label: 'Mark as default',
  },
]
